// extracted by mini-css-extract-plugin
export default {"item":"DragAndDrop_item__C15PE","dragHandle":"DragAndDrop_dragHandle__cl96f"};